import { Stack, Typography, useTheme } from '@mui/material';

import type { ImageCarouselSidebarProps } from '../ImageCarousel/ImageCarousel';

export const ImageCarouselSidebar = ({ label, children }: ImageCarouselSidebarProps) => {
  const theme = useTheme();
  return (
    <Stack sx={{ backgroundColor: theme.palette.background.default }} height="100%">
      <Typography variant="h5" fontWeight="bold" paddingX={4} paddingY={2}>
        {label}
      </Typography>
      {children}
    </Stack>
  );
};
